import { ContactComponent } from './contact/contact.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AccountComponent } from './account/account.component';
import { ConfirmRegisterComponent } from './confirm-register/confirm-register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MovieComponent } from './movie/movie.component';
import { SearchComponent } from './search/search.component';
import { PagesComponent } from './pages.component';
import { SearchGenreComponent } from './search-genre/search-genre.component';
import { SuscriptionComponent } from './suscription/suscription.component';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { FilmicArchiveComponent } from './filmic-archive/filmic-archive.component';
import { FaqComponent } from './faq/faq.component';
import { MemberMoviesComponent } from './member-movies/member-movies.component';
import { PressMoviesComponent } from './press-movies/press-movies.component';
import { SmarttvComponent } from './smarttv/smarttv.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ProfileComponent } from './profile/profile.component';
import { ReconnectComponent } from './reconnect/reconnect.component';
import { TagSearchComponent } from './tag-search/tag-search.component';
import { UiMovieComponent } from './ui-movie/ui-movie.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { UserCommentsComponent } from './user-comments/user-comments.component';
//import { CafComponent } from './caf/caf.component';
import { CafLoginComponent } from './caf-login/caf-login.component';
import { PrivacidadComponent } from './privacidad/privacidad.component';
import { FelixOliverComponent } from './felix-oliver/felix-oliver.component';
import { MembershipInfoComponent } from './membership-info/membership-info.component';
import { AboutFelixOliverComponent } from './about-felix-oliver/about-felix-oliver.component';
import { CatalogueFelixOliverComponent } from './catalogue-felix-oliver/catalogue-felix-oliver.component';
import { AboutFelixOliverOldComponent } from './about-felix-oliver-old/about-felix-oliver-old.component';
import { SubsInfoComponent } from './subs-info/subs-info.component';


const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      { path: 'home', component: HomeComponent },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'registro',
        component: RegisterComponent,
      },
      {
        path: 'suscripcion',
        component: SuscriptionComponent,
      },
      {
        path: 'auth/reset-password',
        component: ConfirmRegisterComponent,
      },
      {
        path: 'olvido',
        component: ForgotPasswordComponent,
      },
      {
        path: 'cuenta',
        component: AccountComponent,
      },
      {
        path: 'movie/:id',
        component: MovieComponent,
      },
      {
        path: 'search/:text',
        component: SearchComponent,
      },
      {
        path: 'search-genre/:genre',
        component: SearchGenreComponent,
      },
      {
        path: 'tag-search/:tag/:criteria',
        component: TagSearchComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        path: 'catalogue',
        component: CatalogueComponent,
      },
      {
        path: 'filmic-archive',
        component: FilmicArchiveComponent,
      },
      {
        path: 'sala-de-prensa',
        component: PressMoviesComponent,
      },
      {
        path: 'felix-oliver',
        component: FelixOliverComponent,
      },
      {
        path: 'mi-perfil',
        component: MyProfileComponent,
      },
      {
        path: 'mi-perfil',
        children: [
          {
            path: '',
            component: MyProfileComponent,
          },
          {
            path: 'comentarios',
            component: UserCommentsComponent
          }
        ]
      },
      {
        path: 'perfil/:userId',
        component: ProfileComponent,
      },
      {
        path: 'faq',
        component: FaqComponent,
      },
      // {
      //   path: 'membership-info',
      //   component: MembershipInfoComponent,
      // },
      {
        path: 'membership-info',
        component: SubsInfoComponent,
      },
      {
        path: 'privacidad',
        component: PrivacidadComponent,
      },
      {
        path: 'smarttv',
        component: SmarttvComponent,
      },
      {
        path: 'reconnect',
        children: [
          {
            path: '',
            component: ReconnectComponent,
          },
          {
            path: 'reviews',
            component: ReviewsComponent
          }
        ]
      },
      {
        path: 'cafLogin',
        component: CafLoginComponent
      },
      {
        path: 'felix-oliver-about',
        component: AboutFelixOliverOldComponent,
      },
      {
        path: 'felix-oliver-catalogue',
        component: CatalogueFelixOliverComponent,
      },
      {
        path: 'felix-oliver-membership-info',
        component: AboutFelixOliverComponent,
      },

      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: '**',
        redirectTo: '/home',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
